import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import useTitle from 'react-use/lib/useTitle';

import Icon from 'src/common/components/icons/Icon';
import PageBox from 'src/common/components/PageBox';
import { frostedPanelSx } from 'src/common/styles/frostedPanelStyles';
import { APP_ICON_IDS } from 'src/common/components/icons/iconPicker';

export default function IconList() {
  useTitle('just a page to show all icons');

  return (
    <PageBox sx={{ pt: 4, pb: 4 }}>
      <Grid container sx={{ minHeight: 'calc(100vh - 65px - 85px)' }} spacing={2}>
        {APP_ICON_IDS.map(icon => (
          <Grid size={{ xs: 3, sm: 2 }} key={icon} sx={{
            textAlign: "center"
          }}>
            <Paper
              sx={{
                py: 2,
                px: 2,
                ...frostedPanelSx(0.5),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              elevation={4}
            >
              <Icon
                icon={icon}
                sx={{ color: theme => theme.palette.grey[900] }}
                fontSize="large"
              />
              {icon}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </PageBox>
  );
}
